<!-- More track info (toggled by the wager info icon) -->
@if (showMoreTrackInfo) {
  <div
    data-cy="more-track-info"
    class="
      more-track-info
      tw-w-full
      tw-max-w-[770px]
      tw-block
      tw-bg-[#E5E5E5]
      tw-rounded-[7px]
      tw-border-[1px]
      tw-border-[#A3A3A3]
      tw-mt-[8px]
      tw-py-[6px]
      tw-px-[18px]
    "
  >
    @if (moreTrackInfo.length > 0) {
      <div class="tw-flex tw-flex-wrap tw-gap-x-[18px] tw-gap-y-[4px]">
        @for (item of moreTrackInfo; track item.key) {
          <span
            [attr.data-track-info-key]="item.key"
            class="track-info-item tw-text-[14px] sm:tw-text-[15px] tw-leading-[20px]"
          >
            <span class="tw-font-semibold">{{ item.key | translate: item.label }}:</span>
            {{ item.value }}
          </span>
        }
      </div>
    } @else {
      <span class="track-info-empty tw-text-[14px] sm:tw-text-[15px] tw-leading-[20px]">
        {{
          'ui.wager.no.additional.race.information'
            | translate: 'No additional race information available.'
        }}
      </span>
    }
  </div>
}

<!-- Pool selection -->
<div
  [ngClass]="{'tw-hidden': selectedRace?.Pools?.length === 0}"
  class="
    pool-selection-section
    tw-relative
    tw-w-full
    tw-max-w-[770px]
    tw-overflow-x-auto
    tw-block
    tw-bg-[#E5E5E5]
    tw-rounded-[7px]
    tw-border-[1px]
    tw-border-[#A3A3A3]
    tw-mt-[8px]
    tw-pt-[5px]
    tw-pb-[4px]
    tw-px-[12px]
  "
>
  <div
    class="
      tw-flex
      tw-items-center
      tw-pr-[15px]
      tw-pl-[6px]
    "
  >
    <div
      class="current-pools tw-leading-[32px] tw-whitespace-nowrap"
    >
      @if (selectedRace !== undefined) {
        <!-- OLD: *ngFor="let pool of selectedRace?.Pools" (raw API order) -->
        <span
          [class.active-pool]="selectedPool?.PoolId === pool?.PoolId"
          (click)="selectPool(pool)"
          *ngFor="let pool of getSortedPools()"
          [attr.data-pool-id]="pool?.PoolId"
          class="
            pool-chip
            tw-inline-flex
            tw-items-center
            tw-justify-center
            tw-text-[#FFFFFF]
            tw-text-[16px]
            sm:tw-text-[18px]
            tw-leading-none
            tw-uppercase
            tw-cursor-pointer
            tw-select-none
            tw-bg-[#19385D]
            tw-rounded-[4px]
            tw-mr-[10px]
            tw-px-[10px]
            tw-py-[5px]
            tw-transition-colors
            tw-duration-150
            hover:tw-bg-[#557DAC]
          "
        >
          {{ pool?.PoolName }}
        </span>
      }
    </div>
  </div>
</div>
